module.exports = function anonymous(it
) {
var out='<ul class="js-results"> <li class="js-entity-item"> <div class="centered entity-item table no-results-row js-no-results"> <span class="value" rel="localize[search.no-results-found]"> Your search didn\'t return any results </span> </div> </li></ul>';return out;
}